import { customElement } from "solid-element";
// @ts-ignore
import image from "./assets/empty-data.png";
import { Show } from "solid-js";

document.addEventListener("DOMContentLoaded", function(event) {
  const style = document.createElement('style');
  style.textContent = `builderall-empty-image { width: 100%;display:block;}`;
  document.head.appendChild(style);
});

customElement("builderall-empty-image", { size: '100%', btnLabel: '', btnIcon: '', btnLink: '', btnTarget: '_self' }, (props, { element }) => {

  // Se o usuário não enviar o btn-link, um evento será emitido para dizer que o botão foi clicado
  const handleClick = () => {
    if (!props.btnLink) {
      emitEvent({
        message: "Button clicked 🤪"
      });
    }
  }

  const emitEvent = (detail) => {
    const customEvent = new CustomEvent("builderall-click-empty-image", {
      bubbles: true,
      composed: true,
      detail
    })

    document.dispatchEvent(customEvent)
  };

  return (
    <>
      <style>{require("bundle-text:./styles/index.scss")}</style>
      <div>

        <svg width="1448" style="width:100%" height="1" viewBox="0 0 1448 1" fill="none">
          <line y1="0.5" x2="1448" y2="0.5" stroke="none"/>
        </svg>

        <img src={image} width={props.size} />
        <Show when={props.btnLabel}>
          <a
            href={props.btnLink || undefined}
            target={props.btnLink ? props.btnTarget : undefined}
            onClick={handleClick}
            class="ba-btn ba-blue"
          >
            <Show when={props.btnIcon}>
              <builderall-icon code={props.btnIcon} />
            </Show>
            {props.btnLabel}
          </a>
        </Show>
      </div>
    </>
  );
});
